import { SIGN_UP_AUTH_FORM } from '../constants/common';

import { useAuthModal } from './useAuthModal';

export const useSignUpModal = () => {
  const { openAuthModal } = useAuthModal({
    type: SIGN_UP_AUTH_FORM,
  });

  return {
    openSignUpModal: openAuthModal,
  };
};
